import type { HelpCategory } from "../../types";

export const faq: HelpCategory = {
  id: "faq",
  title: "Частые вопросы",
  description: "Короткие ответы на то, что спрашивают чаще всего.",
  icon: "help",
  articles: [
    {
      id: "faq-common",
      title: "Частые вопросы и ошибки",
      summary: "Почему раздел с замком, себестоимость 0, остаток в минусе, «данные изменил другой пользователь» и другие ситуации.",
      keywords: ["ошибка", "не работает", "почему", "замок", "409", "402", "минус", "нет прав"],
      body: [
        {
          t: "faq",
          items: [
            { q: "Раздел в меню с замком", a: "Он не входит в ваш тариф. Нажмите на него — откроется описание и кнопка «Подключить». См. [[subscription]]." },
            { q: "Нужного раздела нет в меню", a: "У вашей роли нет права на него. Попросите владельца добавить право в роль: [[users-roles]]." },
            { q: "«Данные изменил другой пользователь»", a: "Пока вы редактировали, кто-то сохранил изменения. Закройте окно и откройте снова — увидите актуальную версию." },
            { q: "«Достигнут лимит тарифа»", a: "Лимит филиалов, терминалов, пользователей или складов исчерпан. Увеличьте тариф или подключите пакет в «Подписке»." },
            { q: "Себестоимость блюда 0 или «неполная»", a: "Нет техкарты или у продуктов нет цены закупки. См. [[recipes]] и [[purchases]]." },
            { q: "Остаток продукта в минусе", a: "Продали больше, чем было по учёту. Проведите закупку или инвентаризацию — минус погасится. См. [[stock-balances]]." },
            { q: "Продажи не списывают продукты", a: "У блюда нет опубликованной техкарты, или у варианта своя пустая ТТК. См. [[recipes]]." },
            { q: "Касса просит PIN менеджера", a: "Действие больше лимита вашей роли. См. [[pos-discounts]]." },
            { q: "«Кассовая смена не открыта»", a: "Откройте смену в «Кассовых сменах». См. [[cash-shifts]]." },
            { q: "Сотрудник не может войти по PIN", a: "Устройство не зарегистрировано как терминал, у сотрудника нет PIN или он уволен; после 5 ошибок PIN блокируется на 15 минут. См. [[terminals]]." },
            { q: "Не вижу данных — всё пусто", a: "Проверьте филиал в шапке и период в фильтре." },
            { q: "Время в отчётах не совпадает", a: "Проверьте часовой пояс и начало бизнес-дня филиала: [[company-branches]]." },
          ],
        },
      ],
    },
  ],
};
